import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_the_belt_areas_of_compressors_and_generators_fully_enclosed'

export const dataPointDefinition = {
  retracedId: 'are_the_belt_areas_of_compressors_and_generators_fully_enclosed',
  name: 'Are the belt areas of compressors and generators fully enclosed and guarded?',
  description: 'If the facility does not have compressors/generators, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-47--1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16690,
  sectionId: '2.2.9.9',
  impactArea: 'Electrical Safety',
  impactAreaId: 'ELECTRICAL_SAFETY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
